<template>
  <div class="page inteboStore" style="background-color: #ffffff">
    <el-container style="height: 100%">
      <el-header style="height: 40px">
        <el-form :inline="true" class="demo-form-inline">
          <!--<el-form-item label="职位">
            <el-select v-model="parentid" style="width: 120px" size="mini" placeholder="" @change="parentChange">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.parentname" :value="item.parentid" :key="key" v-for="(item,key) in parentInfos"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item style="margin-top: 7px">
            <el-input size="mini" v-model="param" clearable @clear="getInteboStore" style="width: 200px;">
              <el-button slot="append" type="primary" icon="el-icon-search" @click="getInteboStore"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="openAddStore" size="mini">新增门店</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main style="height: 100%">
        <el-table height="calc(100%)"  border :data="inteboStores" size="mini" style="text-align: center" highlight-current-row>
          <el-table-column label="门店名称"  align="center"prop="storename">
              <template slot-scope="scope">
                  <div>{{scope.row.storename}}</div>
                  <div style="color: red"><span v-if="scope.row.salecount>0">赠送店销:{{scope.row.salecount}}次</span></div>
              </template>
          </el-table-column>
          <el-table-column label="品牌名称"  align="center"prop="parentname"></el-table-column>
          <el-table-column label="手机号码" width="110" align="center" prop="phone"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
                <el-button @click="updateInteboStore(scope.row)" type="text" size="small">修改</el-button>
                <el-button @click="deleteInteboStore(scope.row)" type="text" size="small" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
    data() {
        return {
            param: "",
            parentid: "",
            parentInfos: [],
            inteboStores: [],
        }
    },
    created() {
        this.getInteboParentStore();
        this.getInteboStore();
        /*let userId = this.$getUrlKey("userId");
        let code = this.$getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCode?state=10";
        }*/
    },
    methods: {
        getCorpUserInfo(staffid) {
            this.$post("wechat/getInteboCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        //如果钉钉没找到就关闭页面
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        this.getInteboParentStore();
                        this.getInteboStore();
                    }
                }
            });
        },
        deleteInteboStore(row) {
            this.$dialog.confirm({
                title: '删除',
                message: "您确定要删除该门店资料吗",
            }).then(() => {
                this.$post("inteboStore/deleteInteboStore", {storeid: row.storeid}).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                        duration: 1000
                    });
                    this.getInteboStore();
                });
            });
        },
        updateInteboStore(row) {
            this.$router.push({
                path: '/addintebostore', query: {
                    type: "update",
                    updateInteboStore: row
                }
            });
        },
        openAddStore() {
            this.$router.push({
                path: '/addintebostore', query: {
                    type: "add"
                }
            });
        },
        parentChange() {
            this.getInteboStore();
        },
        getInteboStore() {
            this.$post("inteboStore/getInteboStore", {parentid: this.parentid, param: this.param}).then(res => {
                if (res.sucess) {
                    this.inteboStores = res.object;
                }
            });
        },
        getInteboParentStore() {
            this.$post("inteboStore/getInteboParentStore").then(res => {
                if (res.sucess) {
                    this.parentInfos = res.object;
                }
            });
        }
    }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
.inteboStore .el-main{
  padding:0px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/page/intebo/intebostore/intebostore.vue